import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';
import { Observable } from 'rxjs';
import { map } from 'lodash';

import { AppService } from '../../../services/app.service';
import { InternalProductWithFavoriteStatusType } from '@sifca-monorepo/ecommerce-generator';

@Component({
  template: '',
})
export class BaseProductGalleryComponent implements OnInit {
  @Input() product: InternalProductWithFavoriteStatusType;
  @Input() adClass = 'product-gallery-vertical';

  currentIndex = 0;
  album = [];
  lightBoxOption = {
    showImageNumberLabel: true,
    centerVertically: true,
    showZoom: true,
    fadeDuration: 0.2,
    albumLabel: '%1 / %2',
  };

  barcodeIndex$: Observable<number>;
  barcodeInedex: number;

  constructor(
    protected lightBox: Lightbox,
    protected appService: AppService,
  ) {
    this.barcodeIndex$ = this.appService.barcodeIndex$;
  }

  @HostListener('window:resize', ['$event'])
  closeLightBox(event: Event) {
    this.lightBox.close();
  }

  ngOnInit(): void {
    this.barcodeIndex$.subscribe((index: any) => {
      this.album = [];
      this.barcodeInedex = index;
      this.appService.product$.subscribe((res: any) => {
        if (res) {
          res?.barcodes[index]?.media?.pictures
            ? map(res.barcodes[index]?.media?.pictures, (pic) => {
                this.album.push({
                  src: pic.baseUrl + '/' + pic.path,
                  thumb: pic.baseUrl + '/' + pic.path,
                  caption: this.product.name,
                });
              })
            : [];
        }
      });
    });
  }

  changeImage($event: Event, index = 0) {
    this.currentIndex = index;
    $event.preventDefault();
  }

  openLightBox() {
    this.lightBox.open(this.album, this.currentIndex, this.lightBoxOption);
  }
}
